import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  fetchMyApps,
  selectAppCategories,
  selectForYouApps,
  selectAppCategoriesWithApps,
  selectMyAppsCallStatus,
} from '../../../appSlice'
import SeeAllAppsMobileStyles from './SeeAllAppsMobileStyles'
import ShowAppList from '../../../AppComponents/ShowAppList/ShowAppList'
import BackButtonNavBar from '../../../../../CommonComponents/BackButtonNavBar/BackButtonNavBar'
import { useTitle } from '../../../../../navigation/helpers/useTitle'
/**
 * All Apps tab in mobile view
 * Displays all applications
 */
export const SeeAllAppsPageMobile = () => {
  useTitle('My Rutgers Apps')
  const classes = SeeAllAppsMobileStyles()
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [appList, setAppList] = React.useState([])
  const [categoryTitle, setCategoryTitle] = React.useState('')

  const appCategory = useSelector(selectAppCategories)
  const appCategoriesWithApps = useSelector(selectAppCategoriesWithApps)
  const forYouApps = useSelector(selectForYouApps)
  const status = useSelector(selectMyAppsCallStatus)

  React.useEffect(() => {
    if (status === 'idle' || status === 'pending') {
      dispatch(fetchMyApps())
    } else {
      const query = location.search
      const id = new URLSearchParams(query).get('id')
      const type = new URLSearchParams(query).get('type')

      if (
        type.toLowerCase() === 'slider' ||
        type.toLowerCase() === 'carousel'
      ) {
        const category = appCategory.filter((c) => c.id === id)[0]
        const appsList = appCategoriesWithApps.filter(
          (c) => c.name === category.name,
        )[0]
        setCategoryTitle(category.name)
        setAppList(appsList.apps)
      } else if (type.toLowerCase() === 'foryou') {
        const category = forYouApps.filter((l) => {
          let returnValue = false

          if (l.fragmentList?.[0]?.apps?.length === 0) {
            // CASE 0
            // checks for empty array
          } else if (
            l.fragmentList?.[0]?.categoryName === id &&
            l.renderType === 'appList'
          ) {
            // CASE 1
            // checks for matches category name to category selected
            returnValue = true
          } else if (
            l.fragmentList?.[0]?.categoryName.substring(0, 4) ===
              id.substring(0, 4) &&
            l.renderType === 'appList' &&
            !returnValue &&
            !id.includes('Most ') && // to avoid "Most Popular" and "Most Trending"
            !id.includes('Employee') // to avoid "New Employee"
          ) {
            // CASE 2 for New & Featured Apps
            // special case because the "&" causes issue with the ID
            returnValue = true
          } else {
            returnValue = false
          }
          return returnValue
        })
        setCategoryTitle(category[0]?.fragmentList[0]?.categoryName)
        setAppList(category[0]?.fragmentList[0]?.apps)
        // below logic handles for if category is not found above
        if (category.length === 0) {
          // CASE 3 - handle apps coming from category[2] fragment card
          forYouApps[2].fragmentList.forEach((l) => {
            if (l?.categoryName === id) {
              let appsToSet = []
              l?.associatedApps.forEach((c) => {
                appsToSet = [...appsToSet, ...c.apps]
              })
              // aggregate apps from all categories into one array with no duplicates
              const noDuplicates = Array.from(
                new Set(appsToSet?.map(JSON.stringify)),
              ).map(JSON.parse)
              appsToSet = noDuplicates
              setCategoryTitle(l?.categoryName)
              setAppList(appsToSet)
            }
          })
        }
      }
    }
  }, [status])

  return (
    <div className={classes.container}>
      <BackButtonNavBar onClick={() => history.goBack()} name={categoryTitle} />
      <div className={classes.appListContainer}>
        <ShowAppList inputAppList={appList} category={categoryTitle} />
      </div>
    </div>
  )
}

export default SeeAllAppsPageMobile
